module.exports = __webpack_public_path__ + "img/12.653257cd.png";